import { Card, Radio, Input, Button } from "antd";
import { Printer, Save } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function TabMedicalHistory() {
    const { t } = useTranslation();

    const diseases = [
        t('skin_care.disease_cardiovascular'),
        t('skin_care.disease_diabetes'),
        t('skin_care.disease_hiv'),
        t('skin_care.disease_thyroid'),
        t('skin_care.disease_kidney_liver'),
        t('skin_care.disease_hepatitis'),
    ];

    return (
        <Card>

            {/* Alert */}

            <div className="bg-pink-50 dark:bg-pink-900/20 text-pink-600 dark:text-pink-300 p-3 rounded mb-5">
                {t('skin_care.medical_note')}
            </div>

            {/* Diseases */}

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">

                {diseases.map((item) => (

                    <Card
                        key={item}
                        size="small"
                        className="dark:bg-slate-800"
                    >

                        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">

                            <span className="text-000000e0 dark:text-gray-200">
                                {item}
                            </span>

                            <Radio.Group>
                                <Radio value="yes">{t('skin_care.yes')}</Radio>
                                <Radio value="no">{t('skin_care.no')}</Radio>
                            </Radio.Group>

                        </div>

                    </Card>

                ))}

            </div>

            {/* Cancer */}

            <div className="mt-6">

                <div className="mb-2 text-000000e0 dark:text-gray-200">
                    {t('skin_care.malignant_diseases')}
                </div>

                <Input.TextArea rows={3} />

            </div>

            {/* Medicine */}

            <div className="mt-5">

                <div className="mb-2 text-000000e0 dark:text-gray-200">
                    {t('skin_care.current_medication')}
                </div>

                <Input.TextArea rows={3} />

            </div>

            {/* Footer */}

            <div className="flex flex-col sm:flex-row justify-end gap-3 mt-6">

                <Button icon={<Printer size={16} />}>
                    {t('skin_care.print')}
                </Button>

                <Button type="primary" icon={<Save size={16} />}>
                    {t('skin_care.save')}
                </Button>

            </div>

        </Card>
    );
}